<template>
    <v-card class="stat-card hover-card pa-4">
        <div class="card-content">
            <div class="card-text">
                <div class="card-title"><v-btn variant="outlined"
                        class="rounded-pill border-white text-none pill-btn">{{ title }}</v-btn></div>
                <div class="card-value">{{ value }}</div>
            </div>
            <div class="progress-container">
                <div class="multi-segment-bar">
                    <div class="segment green" :style="{ width: green + '%' }"></div>
                    <div class="segment red" :style="{ width: red + '%' }"></div>
                    <div class="segment orange" :style="{ width: orange + '%' }"></div>
                </div>

                <div class="d-flex justify-space-between mt-1">
                    <span class="text-subtitle-2">Legacy Balance {{ legacy }}</span>
                    <!-- <span class="text-subtitle-2">Withdraw: {{ red }}%</span>
                    <span class="text-subtitle-2">Other: {{ orange }}%</span> -->
                </div>
            </div>
            <div class="d-flex justify-center gap-6 mt-4" style="margin-bottom: 3%; gap: 1%;" @click="goToPortfolio">
                <!-- Add Money -->
                <v-btn variant="flat" color="#0f2638" class="rounded-pill text-none d-flex align-center px-3">
                    View Portfolio
                    <v-icon class="ms-2" color="green">mdi-arrow-right-circle-outline</v-icon>
                </v-btn>

            </div>

        </div>
    </v-card>
</template>

<script setup>
import { VCard } from 'vuetify/components'
import { ref } from "vue"
import { useRouter } from 'vue-router';

defineProps({
    title: String,
    value: [String, Number],
    legacy: [String, Number],
    subtext: String,
    icon: { type: String },
    iconColor: { type: String, default: '#0f2638 ' },
    textColor: { type: String, default: '#64cf69' },
    background: {
        type: String,
        default: '#FFFFFF',
    },
})

const router = useRouter()
const green = ref(70)
const red = ref(10)
const orange = ref(20)

//got portfolio
const goToPortfolio = () => {
    router.push('/portfolio')
}
</script>

<style scoped>
.stat-card {
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    min-height: 140px;
    transition: transform 0.2s, box-shadow 0.2s;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    background: #FFFFFF;
}

.hover-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.stat-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.stat-content {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.stat-text {
    display: flex;
    flex-direction: column;
    margin-bottom: 5%;
    /* justify-content: center; */
}

.card-text {
    margin-bottom: 2.5%;
}

.card-title {
    font-size: 14px;
    color: #0f2638;
    font-weight: 500;
    width: 100%;

}

.card-value {
    font-size: 20px;
    font-weight: 600;
    margin: 4px 0;
}

.stat-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
}

.pill-btn {
    display: inline-block;
    padding: 8px 16px;
    border: 1px solid #0f2638;
    border-radius: 999px;
    background: transparent;
    transition: all 0.3s ease;
    width: 70%;
    margin: 3% 5%;
}

.progress-container {
    width: 70%;
    max-width: 70%;
    margin: 0 auto; /* center everything */
}

.multi-segment-bar {
    display: flex;
    height: 8px;
    border-radius: 12px;
    overflow: hidden;
    background: #e0e0e0;
    margin: 0 auto;
}

.segment {
    height: 100%;
    transition: width 0.5s ease;
}

/* segment colors */
.green {
    background-color: #4caf50;
}

.red {
    background-color: #f44336;
}

.orange {
    background-color: #ff9800;
}

</style>